export default "/assets/images/filter-07.8911e71cfabc9292.svg";